module.exports = __webpack_public_path__ + "common/icon-drawer-menu-d33388139f6b9d2b7fdd87709165c46b.svg";